export const CHECKOUT_WEB_XP: { [key: string]: string } = {
    INCREASE_TURBO_SLIDER_AREA: "increase_turbo_slider_area",
    AUTOPAY_ABANDONMENT_FEEDBACK: "autopay_back_feedback",
    EMPTY_CART_REDIRECT: "empty_cart_redirect",
    NEW_ADDRESS_FORM_ENABLED: "new_address_form_enabled",
};

export const CHECKOUT_WEB_WP: { [key: string]: string; WEB_CART_SAVINGS_STAMP_FREQUENCY_THRESHOLD: string } = {
    WEB_CART_SAVINGS_STAMP_FREQUENCY_THRESHOLD: "web_cart_savings_stamp_frequency_threshold",
    FOOD_CART_INCOGNITO_FEATURE_FLAG: "food_cart_incognito_feature_flag",
    ENABLE_REMOVE_COUPON_PUBLIC_ENDPOINT: "enable_remove_coupon_public_endpoint",
    CW_PUBLIC_ENDPOINT_CONFIG: "cw_public_endpoint_config",
    // Note: This is to add wp config values for checkout web in future without adding new keys in config platform. It is advised to add simple boolean or string values in this rather than complex objects. For complex wp options it is highly recommended to add a new key in config platform.
    CW_WP_CONFIG: "cw_wp_config",
};

export const CHECKOUT_WEB_PUBLIC_ENDPOINT_KEYS = {
    CW_PUBLIC_ENDPOINT_CONFIG: "cw_public_endpoint_config",
    CART_APIS: "cart_apis",
    APPLY_COUPON: "apply_coupon",
    GET_CART: "get_cart",
    UPDATE_CART: "update_cart",
    WALLET_APIS: "wallet_apis",
    CARDS_JUSPAY_APIS: "cards_juspay_apis",
    GPO_UPI: "gpo_upi",
    ORDER_APIS: "order_apis",
    FETCH_COUPONS: "fetch_coupons",
    PAYMENT_APIS: "payment_apis",
    AMAZON_PAY: "amazon_pay",
    VERIFY_VPA: "verify_vpa",
    GET_BANKS_LIST: "get_banks_list",
    GET_PAYMENT_FALLBACK_METHODS: "get_payment_fallback_methods",
    CHECK_TXN_STATUS: "check_txn_status",
    CREATE_PENNY_TRANSACTION: "create_penny_transaction",
    CONFIRM_PENNY_TRANSACTION: "confirm_penny_transaction",
    GET_ALL_REFUND_OPTIONS: "get_all_refund_options",
    SET_REFUND_OPTION: "set_refund_option",
    PAYLATER_APIS: "paylater_apis",
    GPO_PAYMENT_APIS: "gpo",
    UPDATE_FREQUENCY_COUNTER: "update_frequency_counter",
    REGISTER_PAY_ON_DELIVERY: "register_pay_on_delivery",
    JUSPAY_CLIENT_TOKEN: "juspay_client_token",
    PLACE_ORDER: "place_order",
    CONFIRM_ORDER: "confirm_order",
    CONFIRM_ON_APP_LAUNCH: "confirm_on_app_launch",
} as const;

export const CHECKOUT_WEB_WP_CONFIG_KEYS = {
    ENABLE_DO_WV_REFRESH: "enable_do_wv_refresh",
    ENABLE_JUSPAY_V3_AUTH_TOKEN: "enable_juspay_v3_auth_token",
} as const;

export interface CheckoutWebWPConfig {
    [CHECKOUT_WEB_WP_CONFIG_KEYS.ENABLE_DO_WV_REFRESH]: boolean;
    [CHECKOUT_WEB_WP_CONFIG_KEYS.ENABLE_JUSPAY_V3_AUTH_TOKEN]?: boolean;
}

export interface CartApis {
    [CHECKOUT_WEB_PUBLIC_ENDPOINT_KEYS.APPLY_COUPON]: string;
    [CHECKOUT_WEB_PUBLIC_ENDPOINT_KEYS.GET_CART]: string;
    [CHECKOUT_WEB_PUBLIC_ENDPOINT_KEYS.UPDATE_CART]: string;
    [CHECKOUT_WEB_PUBLIC_ENDPOINT_KEYS.FETCH_COUPONS]: string;
}

export type WalletApis = Record<string, string>;
export type CardsJuspayApis = Record<string, string>;
export type GpoUpiApis = Record<string, string>;
export type OrderApis = Record<string, string>;
export type PaymentApis = Record<string, string>;
export type PayLaterApis = Record<string, string>;
export type CardApis = Record<string, string>;

export interface EnableCWPublicEndpoint {
    [CHECKOUT_WEB_PUBLIC_ENDPOINT_KEYS.CART_APIS]: CartApis;
    [CHECKOUT_WEB_PUBLIC_ENDPOINT_KEYS.WALLET_APIS]: WalletApis;
    [CHECKOUT_WEB_PUBLIC_ENDPOINT_KEYS.CARDS_JUSPAY_APIS]: CardsJuspayApis;
    [CHECKOUT_WEB_PUBLIC_ENDPOINT_KEYS.GPO_UPI]: GpoUpiApis;
    [CHECKOUT_WEB_PUBLIC_ENDPOINT_KEYS.ORDER_APIS]: OrderApis;
    [CHECKOUT_WEB_PUBLIC_ENDPOINT_KEYS.PAYMENT_APIS]: PaymentApis;
    [CHECKOUT_WEB_PUBLIC_ENDPOINT_KEYS.PAYLATER_APIS]: PayLaterApis;
}

export interface CheckoutWebWP {
    [CHECKOUT_WEB_PUBLIC_ENDPOINT_KEYS.CW_PUBLIC_ENDPOINT_CONFIG]: EnableCWPublicEndpoint;
}

export const CARD_API_KEYS = {
    GET_SODEXO_BALANCE: "get_sodexo_balance",
    GET_ALL_CARDS: "get_all_cards",
    GET_CARD_DETAILS: "get_card_details",
    GET_CARD_OFFER: "get_card_offer",
    DELETE_CARD: "delete_card",
    UPDATE_CARD: "update_card",
};
